<div class="row border-bottom">
  <nav class="navbar navbar-static-top" role="navigation" style="margin-bottom: 0">
    <div class="navbar-header">
      <a class="minimalize-styl-2 btn btn-primary " (click)="toggleNavigation()"><i class="fa fa-bars"></i> </a>
      <form role="search" class="navbar-form-custom" method="post" action="#">
        <div class="form-group">
          <app-combo-autocomplete
              [tabla]=tabla
          ></app-combo-autocomplete>
        </div>
      </form>
    </div>
    <ul class="nav navbar-top-links navbar-right">
      <li><img alt="image" width="80" src="assets/images/liqüihm_logo_violeta.png"  style="padding-right: 10px"></li>
      <!-- <li>
        <a href="http://44.212.120.6/"  target="_blank"><i class="fa fa-1x fa-cog"></i></a>
      </li> -->
      <li>
        <a (click)="cerrarSesion()">
          <i class="fa fa-1x fa-sign-out"></i> Cerrar Sesión 
        </a>
      </li>
    </ul>
  </nav>
</div>
